/** The texts of the filter bar on the images page (IMG-06, COL-02), spread into the app's dictionaries (`lib/i18n.tsx`). */
export const queryEn = {
  queryPlaceholder: 'Describe the images: fracture or dislocation of the elbow, girls under 10, without checked',
  queryLabel: 'Describe the images to find',
  queryEnterApplies: 'Enter applies',
  queryClearAll: 'Remove all filters',
  queryBackToSaved: 'Back to the collection’s filters',
  queryFilterCount: '{count} filters',
  queryFilterCount_one: '1 filter',
  queryApply: 'Apply',
  queryReadAs: 'Read as',
  queryMeans: 'Means',
  queryNotRead: 'Not read',
  queryAnd: 'and',
  queryOr: 'or',
  queryNot: 'not',
  queryAnyOf: 'Any of these',
  queryAllOf: 'All of these',
  queryNothingRead: 'Nothing read yet: every image',
  queryLive: '→ {studies} studies · {images} images',
  queryCounting: '→ counting…',
  queryUseFix: 'Use “{fix}”',
  queryUseAllFixes: 'Use all {count} corrections',
  queryUnreadStayOut: 'Words not read stay out of the search until you change them. Words in quotes are looked for in comments and reports.',
  queryRewritten: 'Written back as query text from the filter you edited.',
  queryEveryones: 'everyone’s you may see',
  queryOnlyYours: 'only yours',
  queryEveryonesChoice: 'Everyone’s I may see',
  queryOnlyMine: 'Only mine',
  queryHasIt: 'Has it',
  queryWhose: 'Whose',
  queryFromYears: 'From (years)',
  queryToYears: 'To (years)',
  queryAnyValue: 'any',
  queryEditDone: 'Done',
  queryEditWrites: 'Editing writes the filter back as query text:',
  queryRemove: 'Remove {what}',
  queryKeptUploads: 'Also only these {count} uploads',
  querySyntax: 'Search syntax',
  querySyntaxIntro: 'Write it as you would say it; below the field, each word shows what it became.',
  queryHelpQuality: 'one fracture with that quality',
  queryHelpOr: '“or” binds first: either finding, and age 9',
  queryHelpBrackets: 'brackets group',
  queryHelpEither: 'either region · 8.0 to 12.9 years',
  queryHelpWithout: 'no image of the study has it · neither',
  queryHelpMine: 'only yours; otherwise everyone’s you may see',
  queryHelpGerman: 'German words work too',
  querySuggestStart: 'What to look for',
  querySuggestMatches: 'Matches for “{fragment}”',
  querySuggestFinding: 'After {label}: its qualities narrow this same finding',
  querySuggestAttribute: 'A value for {attribute}',
  querySuggestAge: 'Whole years are completed years: 9 means 9.0 to 9.9',
  querySuggestField: 'Values of {field}',
  queryKeysComplete: 'complete',
  queryKeysApply: 'apply',
  queryKeysClose: 'close; again: back to what is applied',
  queryGroupValue: 'Values',
  queryGroupAge: 'Age',
  queryGroupAgeGroup: 'Age groups',
  queryGroupQuality: 'Qualities',
  queryGroupWhose: 'Whose',
  queryGroupField: 'Fields',
  queryGroupFinding: 'Findings',
  queryGroupReading: 'Reading',
  queryGroupFix: 'Did you mean',
  queryGroupStart: 'Try',
  queryGroupOr: 'Or',
  queryShape: 'shape',
  queryTag: 'image tag',
  queryIssueUnknownWord: '“{word}” is not a field, value or label',
  queryIssueDidYouMean: 'Did you mean “{fix}”?',
  queryIssueBareNumber: 'A number alone: did you mean age {number}?',
  queryIssueOpNeedsField: '“{op}” needs a field before it, such as age < 10 or subtlety < 0.3',
  queryIssueNeedsValue: '{attribute} needs a value',
  queryIssueOutOfRange: '{attribute} runs from {min} to {max}',
  queryIssueBetweenTwo: '“between” needs two values',
  queryIssueNoSuchValue: 'No {field} is called “{word}”',
  queryIssueNoSuchLabel: 'No label is called “{word}”',
  queryIssueByValue: '“by:” takes me or anyone',
  queryIssueIsValue: '“is:” takes assigned, finished, resolved or annotated',
  queryIssueAgeNeedsValue: 'Age needs a value, such as age 9 or age 8-12',
  queryIssueAgeRange: 'Age takes a value or a range',
  queryIssueAgesApart: 'No age is in both ranges',
  queryIssueExcludeFact: 'Excluding values of {field} is not possible yet',
  queryIssueExcludeGroup: 'Excluding a group with image facts is not possible yet',
  queryIssueNothingToExclude: '“{word}” has nothing after it to exclude',
  queryIssueOrAtEnd: '“or” has nothing after it',
  queryIssueListTakesValues: '{field} takes values, not “{op}”',
  queryIssueTextLength: 'Words in quotes: 1 to 100 characters',
  conditionText: 'words in comments and reports',
  queryWords: 'Words',
}

export const queryDe: Record<keyof typeof queryEn, string> = {
  queryPlaceholder: 'Bilder beschreiben: Fraktur oder Luxation am Ellbogen, Mädchen unter 10, ohne geprüft',
  queryLabel: 'Gesuchte Bilder beschreiben',
  queryEnterApplies: 'Enter wendet an',
  queryClearAll: 'Alle Filter entfernen',
  queryBackToSaved: 'Zurück zu den Filtern der Sammlung',
  queryFilterCount: '{count} Filter',
  queryFilterCount_one: '1 Filter',
  queryApply: 'Anwenden',
  queryReadAs: 'Gelesen als',
  queryMeans: 'Bedeutet',
  queryNotRead: 'Nicht gelesen',
  queryAnd: 'und',
  queryOr: 'oder',
  queryNot: 'nicht',
  queryAnyOf: 'Eines davon',
  queryAllOf: 'Alle davon',
  queryNothingRead: 'Noch nichts gelesen: alle Bilder',
  queryLive: '→ {studies} Studien · {images} Bilder',
  queryCounting: '→ zählt…',
  queryUseFix: '„{fix}“ verwenden',
  queryUseAllFixes: 'Alle {count} Korrekturen verwenden',
  queryUnreadStayOut: 'Nicht gelesene Wörter bleiben aus der Suche, bis Sie sie ändern. Wörter in Anführungszeichen werden in Kommentaren und Befunden gesucht.',
  queryRewritten: 'Aus dem bearbeiteten Filter als Abfragetext neu geschrieben.',
  queryEveryones: 'von allen, die Sie sehen dürfen',
  queryOnlyYours: 'nur Ihre',
  queryEveryonesChoice: 'Von allen, die ich sehen darf',
  queryOnlyMine: 'Nur meine',
  queryHasIt: 'Vorhanden',
  queryWhose: 'Von wem',
  queryFromYears: 'Von (Jahre)',
  queryToYears: 'Bis (Jahre)',
  queryAnyValue: 'beliebig',
  queryEditDone: 'Fertig',
  queryEditWrites: 'Bearbeiten schreibt den Filter als Abfragetext zurück:',
  queryRemove: '{what} entfernen',
  queryKeptUploads: 'Zusätzlich nur diese {count} Uploads',
  querySyntax: 'Suchsyntax',
  querySyntaxIntro: 'Schreiben Sie es, wie Sie es sagen würden; unter dem Feld zeigt jedes Wort, was daraus wurde.',
  queryHelpQuality: 'eine Fraktur mit dieser Eigenschaft',
  queryHelpOr: '„oder“ bindet zuerst: einer der Befunde, und Alter 9',
  queryHelpBrackets: 'Klammern gruppieren',
  queryHelpEither: 'eine der Regionen · 8,0 bis 12,9 Jahre',
  queryHelpWithout: 'kein Bild der Studie hat es · keines von beiden',
  queryHelpMine: 'nur Ihre; sonst die aller, die Sie sehen dürfen',
  queryHelpGerman: 'Deutsche Wörter gehen auch',
  querySuggestStart: 'Wonach suchen',
  querySuggestMatches: 'Treffer für „{fragment}“',
  querySuggestFinding: 'Nach {label}: seine Eigenschaften grenzen denselben Befund ein',
  querySuggestAttribute: 'Ein Wert für {attribute}',
  querySuggestAge: 'Ganze Jahre sind vollendete Jahre: 9 heißt 9,0 bis 9,9',
  querySuggestField: 'Werte von {field}',
  queryKeysComplete: 'ergänzen',
  queryKeysApply: 'anwenden',
  queryKeysClose: 'schließen; nochmals: zurück zum Angewendeten',
  queryGroupValue: 'Werte',
  queryGroupAge: 'Alter',
  queryGroupAgeGroup: 'Altersgruppen',
  queryGroupQuality: 'Eigenschaften',
  queryGroupWhose: 'Von wem',
  queryGroupField: 'Felder',
  queryGroupFinding: 'Befunde',
  queryGroupReading: 'Befundung',
  queryGroupFix: 'Meinten Sie',
  queryGroupStart: 'Zum Beispiel',
  queryGroupOr: 'Oder',
  queryShape: 'Form',
  queryTag: 'Bild-Tag',
  queryIssueUnknownWord: '„{word}“ ist kein Feld, Wert oder Label',
  queryIssueDidYouMean: 'Meinten Sie „{fix}“?',
  queryIssueBareNumber: 'Eine Zahl allein: meinten Sie Alter {number}?',
  queryIssueOpNeedsField: '„{op}“ braucht ein Feld davor, etwa age < 10 oder subtlety < 0.3',
  queryIssueNeedsValue: '{attribute} braucht einen Wert',
  queryIssueOutOfRange: '{attribute} reicht von {min} bis {max}',
  queryIssueBetweenTwo: '„zwischen“ braucht zwei Werte',
  queryIssueNoSuchValue: 'Kein Wert von {field} heißt „{word}“',
  queryIssueNoSuchLabel: 'Kein Label heißt „{word}“',
  queryIssueByValue: '„by:“ nimmt me oder anyone',
  queryIssueIsValue: '„is:“ nimmt assigned, finished, resolved oder annotated',
  queryIssueAgeNeedsValue: 'Alter braucht einen Wert, etwa Alter 9 oder Alter 8-12',
  queryIssueAgeRange: 'Alter nimmt einen Wert oder einen Bereich',
  queryIssueAgesApart: 'Kein Alter liegt in beiden Bereichen',
  queryIssueExcludeFact: 'Werte von {field} auszuschließen geht noch nicht',
  queryIssueExcludeGroup: 'Eine Gruppe mit Bildangaben auszuschließen geht noch nicht',
  queryIssueNothingToExclude: 'Nach „{word}“ steht nichts zum Ausschließen',
  queryIssueOrAtEnd: 'Nach „oder“ steht nichts',
  queryIssueListTakesValues: '{field} nimmt Werte, nicht „{op}“',
  queryIssueTextLength: 'Wörter in Anführungszeichen: 1 bis 100 Zeichen',
  conditionText: 'Wörter in Kommentaren und Befunden',
  queryWords: 'Wörter',
}
